// Convert date (YYYY-MM-DD) to date (dd/mm/yyyy)
const formatDatePicker = function(date: string): string {
  if (!date) return String();
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
};
// Convert date (YYYY-MM-DDTHH:mm:ss.sssZ) to date (dd/mm/yyyy hh:mm)
const formatDate = function(date: string): string {
  if (!date) {
    return '';
  } else {
    return new Date(date).toLocaleString('es-ES', { timeZone: 'UTC' });
  }
};
// Convert date (YYYY-MM-DDTHH:mm:ss.sssZ) to date (dd/mm/yyyy)
const formatDateShort = function(date: string): string {
  if (!date) {
    return '';
  } else {
    return new Date(date).toLocaleDateString('es-ES', { timeZone: 'UTC' });
  }
};
// Convert date (YYYY-MM-DDTHH:mm:ss.sssZ) to date (yyyy-mm-dd)
const formatDateToCalendar = function(date: string): string {
  if (!date) return String();
  const currentDate = new Date(date);
  return currentDate.toISOString().split('T')[0];
};

// Convert date 2023-03-27T16:33:22Z(YYYY-MM-DDZHH:mm:ssZ)at utc to locale date
const stringUTCToDate = (expirationDate: string) => {
  const [year, month, day] = expirationDate
    .slice(0, 10)
    .split('-')
    .map(Number);
  const [hour, minute, second] = expirationDate
    .slice(11, 19)
    .split(':')
    .map(Number);

  const utcDate = Date.UTC(year, month - 1, day, hour, minute, second);
  return new Date(utcDate);
};
export {
  formatDatePicker,
  formatDate,
  formatDateShort,
  formatDateToCalendar,
  stringUTCToDate
};
